import { rgba } from 'polished';

const styles = theme => ({
  root: {
    flex: 1,
    position: 'relative',
    display: 'flex',
    margin: [0, 'auto'],
    maxWidth: 1000,
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box'
  },
  frame: {
    position: 'absolute',
    zIndex: 1,
    left: 10,
    right: 10,
    top: 0,
    bottom: 0,
    outline: `2px solid ${theme.color.background.dark}`,
    outlineOffset: 2,
    border: '1px solid ' + rgba(theme.color.secondary.dark, 0.22),
    backgroundColor: 'rgba(5, 5, 8, 0.94)',
    backdropFilter: 'blur(16px)',
    WebkitBackdropFilter: 'blur(16px)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.8)'
  },
  content: {
    position: 'relative',
    zIndex: 2,
    flex: 1,
    minWidth: 0,
    maxWidth: '100%',
    width: '100%',
    boxSizing: 'border-box',
    margin: [10, 10, 10, 20],
    padding: [0, 10, 0, 0],

    '& > *:last-child, & > article > *:last-child': {
      marginBottom: 0
    }
  },

  '@media screen and (min-width: 768px)': {
    root: {
      minHeight: 1
    },
    frame: {
      left: 20,
      right: 20,
      top: 0,
      bottom: 0
    },
    content: {
      overflowX: 'hidden',
      overflowY: 'auto',
      margin: [24, 32, 24, 40],
      padding: [0, 14, 48, 0],
      scrollbarWidth: 'thin',
      scrollbarColor: `${rgba(theme.color.secondary.main, 0.4)} rgba(0, 0, 0, 0.25)`,

      '&::-webkit-scrollbar': {
        width: 5
      },
      '&::-webkit-scrollbar-track': {
        background: 'rgba(0, 0, 0, 0.2)',
        borderRadius: 3
      },
      '&::-webkit-scrollbar-thumb': {
        background: rgba(theme.color.secondary.main, 0.35),
        borderRadius: 3,
        '&:hover': {
          background: theme.color.secondary.main,
          boxShadow: `0 0 6px ${theme.color.secondary.main}`
        }
      }
    }
  },

  '@media screen and (min-width: 1025px)': {
    content: {
      margin: [28, 40, 28, 48],
      padding: [0, 16, 52, 0]
    }
  }
});

export { styles };
